import { ContentCategory, CONTENT_CATEGORY_CONFIG } from './Types'
import { CONTENT_CATEGORY_THUMBNAILS } from 'utils/brandPlans/contentCategories'
import Styles from './ContentTypeSelectorWithCounts.module.scss'
import cx from 'classnames'
import { Text } from 'blaze-ui/Text/Text'
import { CountInput } from 'components/Wizards/CountInput/CountInput'
import { useCategoryCreditCosts } from 'hooks/useCategoryCreditCosts'
import { Credits } from 'blaze-ui/icons/20/Credits'
import { pluralize } from 'utils'
import { POST_NAME_LABEL } from './utils'

interface ContentCategoryCounterProps {
  category: ContentCategory
  count: number
  onCountChange: (category: ContentCategory, count: number) => void
  currentCount?: number
}

export const ContentCategoryCounter = ({
  category,
  count,
  onCountChange,
  currentCount,
}: ContentCategoryCounterProps) => {
  const credits = useCategoryCreditCosts()[category]
  const config = CONTENT_CATEGORY_CONFIG[category]
  const thumbnail = CONTENT_CATEGORY_THUMBNAILS[category]

  const handleCountChange = (count: number) => {
    onCountChange(category, count)
  }

  return (
    <div className={cx(Styles.card)}>
      {!!currentCount && currentCount > 0 && (
        <div className={Styles.currentCountBadge}>
          <Text variant="label" color="var(--light-100)">
            {currentCount} {pluralize(POST_NAME_LABEL[category], currentCount)} currently
          </Text>
        </div>
      )}
      <div className={Styles.thumbnail}>
        <img className={Styles.thumbnailImage} src={thumbnail} alt={config.label} />
      </div>
      <div className={Styles.cardText}>
        <Text>{config.label}</Text>
        <Text variant="metadata" color="var(--dark-60)">
          {config.subtitle}
        </Text>
      </div>
      <div className={Styles.counter}>
        <CountInput
          name={category}
          value={count}
          onChange={handleCountChange}
          min={0}
          max={20}
          merged
          className={Styles.counterInput}
          size="md"
        />
      </div>
      <div className={Styles.creditsLabel}>
        <Credits size={15} color="var(--dark-60)" />
        <Text variant="label" color="var(--dark-60)">
          {credits} {pluralize('credit', credits)} per post
        </Text>
      </div>
    </div>
  )
}
